import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { FirestoreCollectionsPaths } from '../firebase/firebase.conts';
import { firestore } from '../firebase/firebase.utils';

export const fetchJobsFromFirebase = async () => {
  try {
    const jobsRef = collection(firestore, FirestoreCollectionsPaths.jobs);
    const queryRef = query(jobsRef, orderBy('createdOn', 'desc'));
    const querySnapshot = await getDocs(queryRef);

    return {
      data: querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
    };
  } catch (error) {
    return { error };
  }
};
